import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit";
import clsx from "clsx";
import { Constructor } from "../../../shared/ui/constructor/Constructor.js";
import styles from "./Tile.module.scss.js";
const Tile = memo(function Tile2({ layout, widgets, className, ...props }) {
  return /* @__PURE__ */ jsx(CarTile, { className: clsx(styles.tile, className), ...props, children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets }) });
});
export {
  Tile
};
